import '../css/app.css';
import './bootstrap';

import * as Sentry from '@sentry/react';
import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { initAnalytics, trackPageview } from './lib/analytics';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
    // Session Replay — capture 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

initAnalytics();

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Plain Blade views (e.g. the legal pages) load this entry just to get the
// compiled Tailwind CSS — they have no Inertia root element, so skip bootstrapping.
if (document.getElementById('app')) {
    // Inertia visits swap the page component without a full browser
    // navigation, so gtag's automatic (page-load-based) pageview only ever
    // fires once — fire one manually on every subsequent Inertia visit.
    router.on('navigate', (event) => trackPageview(event.detail.page.url));

    createInertiaApp({
        title: (title) => `${title} - ${appName}`,
        resolve: (name) =>
            resolvePageComponent(
                `./Pages/${name}.jsx`,
                import.meta.glob('./Pages/**/*.jsx'),
            ),
        setup({ el, App, props }) {
            const root = createRoot(el);

            trackPageview(window.location.pathname + window.location.search);

            root.render(
                <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
                    <App {...props} />
                </Sentry.ErrorBoundary>
            );
        },
        progress: {
            color: '#4B5563',
        },
    });
}
